import { enumContactSortOption } from '@rematter/frontend-lib-api-client';

import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';

export const useContactsQuery = createQueryHook(
  'shared.selectContact',
  (params: { accountIds?: string[]; searchTerm?: string; ids?: string[] }) => ({
    contacts: {
      __args: {
        filter: {
          ids: params.ids,
          accountIds: params.accountIds,
          searchTerm: params.searchTerm,
        },
        sorting: [enumContactSortOption.FullNameAsc],
        pagination: {
          limit: 20,
          offset: 0,
        },
      },
      page: {
        offset: true,
        limit: true,
        total: true,
      },
      entries: {
        id: true,
        fullName: true,
        email: true,
        phone: true,
        role: true,
      },
    },
  }),
  {
    select: (data) => data?.contacts.entries ?? [],
  },
);

export const SelectContact = createEntityComboBox.remotelySearched(
  'SelectContact',
  useContactsQuery,
  {
    formatLabel: (entity) => entity.fullName,
    formatSubLabel: (entity) => `${entity.role} ・ ${entity.email}`,
  },
);
